import { createSlice } from '@reduxjs/toolkit'
import { register } from '../../../../../../../../../helpers/reducerRegistry'
import { getScoreRangesCreditRisk } from '../../../../../../../../common/header/companyInfo/store/thunk'
import { covertPointRange } from '../../../../../../helper'
import { convertRangeCreditRisk } from '../helper'
import { getScoreCreditRisk } from './thunk'

const initialState = {
  dataCreditRiskScore: {
    scoreValue: 0,
    scoreValue_12M: 0,
    scoreValue_24M: 0,
    scoreRangeNameMediumTer: '',
    scoreRangeNameShortTerm: '',
    modelDescription: '',
  },
  dataScoreRangesCreditRisk: {},
  rangeCreditRisk: [],
  pointRangesChart: [],
  loading: {
    scoreCreditRisk: true,
    scoreRangesCreditRisk: true,
  },
}

export const slice = createSlice({
  name: 'companyAnalysis/companyProfile/creditRiskScore/topComponent',
  initialState,
  reducers: {
    resetStore(state) {
      Object.keys(initialState).forEach((key) => {
        state[key] = initialState[key]
      })
    },
  },
  extraReducers: (builder) => {
    //getScoreCreditRisk
    builder.addCase(getScoreCreditRisk.pending, (state) => {
      state.loading.scoreCreditRisk = true
    })
    builder.addCase(getScoreCreditRisk.fulfilled, (state, action) => {
      state.dataCreditRiskScore = action.payload
        ? action.payload
        : initialState['dataCreditRiskScore']
      state.loading.scoreCreditRisk = false
    })
    builder.addCase(getScoreCreditRisk.rejected, (state, action) => {
      state.loading.scoreCreditRisk = action.payload.loading
    })

    //getScoreRangesCreditRisk
    builder.addCase(getScoreRangesCreditRisk.pending, (state) => {
      state.loading.scoreRangesCreditRisk = true
    })
    builder.addCase(getScoreRangesCreditRisk.fulfilled, (state, action) => {
      state.pointRangesChart = covertPointRange(action.payload)
      state.rangeCreditRisk = action.payload
      state.dataScoreRangesCreditRisk = action.payload
        ? convertRangeCreditRisk(action.payload)
        : initialState['dataScoreRangesCreditRisk']
      state.loading.scoreRangesCreditRisk = false
    })
    builder.addCase(getScoreRangesCreditRisk.rejected, (state, action) => {
      state.loading.scoreRangesCreditRisk = action.payload.loading
    })
  },
})

export const selectDataCreditRiskScore = (type) => (state) => {
  const data = state[slice.name].dataCreditRiskScore
  return type ? data[type] : data
}

export const selectRangeCreditRiskScore = (state) =>
  state[slice.name].dataScoreRangesCreditRisk

export const rangeCreditRiskScoreRaw = (state) =>
  state[slice.name].rangeCreditRisk

export const pointRangesChartCreditRisk = (state) =>
  state[slice.name].pointRangesChart

//loading
export const getLoadingRisk = (type) => (state) =>
  type ? state[slice.name].loading[type] : state[slice.name].loading

export const { resetStore } = slice.actions

register(slice.name, slice.reducer)
